import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
function FormLabel({ className, children, isOptional, renderOnPageBackground, }) {
    return (_jsxs("div", { className: clsx('mb-2 flex justify-between text-sm', renderOnPageBackground
            ? 'text-brand-text-page'
            : 'text-brand-text-content', className), children: [_jsx("div", { children: children }), isOptional && _jsx("div", { className: "opacity-50", children: "Optional" })] }));
}
export default FormLabel;
//# sourceMappingURL=index.js.map